<mat-form-field class="time-filter">
  <mat-label>Date Range</mat-label>
  <mat-select appearance="fill" [(ngModel)]="selectedTimeFilter">
    <mat-option *ngFor="let time of timeFilters" [value]="time" (click)="filter(time)">
      {{time}}
    </mat-option>
  </mat-select>
</mat-form-field>
<kendo-chart *ngIf="!isLoading">
  <kendo-chart-tooltip>
  </kendo-chart-tooltip>
  <kendo-chart-legend position="bottom" orientation="horizontal" [visible]="false">
  </kendo-chart-legend>
  <kendo-chart-series>
    <kendo-chart-series-item name="Total Views" type="line" [data]="chartData" categoryField="Date" field="count"
      [style]="'smooth'" color="#FF69B4" width="3">
    </kendo-chart-series-item>
  </kendo-chart-series>
  <kendo-chart-category-axis>
    <kendo-chart-category-axis-item [maxDivisions]="10" type="date">
    </kendo-chart-category-axis-item>
  </kendo-chart-category-axis>
</kendo-chart>